const isProd = process.env.NODE_ENV === "production";
const logOutput = isProd || true; // always log in production, set true/false to log in local

// TODO: make this dynamic based on the environment
const getStripeCustomerIDFunctionURL = isProd
	? "https://us-central1-aadojo-8bbac.cloudfunctions.net/getstripecustomerid"
	: "http://127.0.0.1:5001/test-preflopmastery/us-central1/getstripecustomerid";

export default async function getStripeCustomerID(email) {
	if (logOutput) console.log("getStripeCustomerID email", email);
	try {
		const response = await fetch(getStripeCustomerIDFunctionURL, {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			method: "POST",
			body: JSON.stringify({ email }),
		});

		const data = await response.json();
		if (logOutput) console.log("getStripeCustomerID data", data);
		return data.customerID; // Extract the customer ID from the response
	} catch (error) {
		console.error("Error fetching Stripe customer ID:", error);
		return null;
	}
}
